import { render, staticRenderFns } from "./assetDetail.vue?vue&type=template&id=7d9070f2&scoped=true&"
import script from "./assetDetail.vue?vue&type=script&lang=ts&"
export * from "./assetDetail.vue?vue&type=script&lang=ts&"
import style0 from "./assetDetail.vue?vue&type=style&index=0&id=7d9070f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9070f2",
  null
  
)

export default component.exports